import { usePartnerByIdQuery } from '@/apis/hooks/partners';
import { matchPath, useLocation } from 'react-router-dom';

const usePartner = () => {
  const { pathname } = useLocation();
  const partnerMatch = matchPath('/partners/:id/*', pathname) || matchPath('/partners/:id', pathname);
  const selectedPartnerId = partnerMatch?.params?.id || '';
  const { data: partner } = usePartnerByIdQuery(selectedPartnerId);

  return partner || null;
};

export default usePartner;
